import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {setActiveTabAction} from '../../QCTabs/Redux/QCTabsActions';
import {TabIndex} from '../../QCTabs/QCTabsTypes';
import {
    toggleSelectedRowAction,
    toggleSelectedMarkerAction,
} from '../Redux/TimelineActions';
import {
    setQCReportsAction,
    resetQCReportsAction,
} from './Redux/QCReportActions';
import {QCReportsState} from './Redux/QCReportReducer';
import MarkerRowContainer from '../MarkerRow/MarkerRowContainer';
import {TimelineState} from '../Redux/TimelineReducer';
import {
    TimelineRow,
    TimelineRowType,
    TimelineMarker,
    QCReportMarker,
} from '../TimelineTypes';

interface TimelineStore {
    selectedMarker: TimelineState;
    qcReport: QCReportsState;
}

export interface State {
    timeline: TimelineStore;
}

interface StateProps {
    markerRowData: TimelineRow;
    selectedRowId: string;
    selectedMarkerId: string;
    tabIndex: TabIndex;
}

export const label = 'QC report';

export const haveTimestamp = (marker: QCReportMarker): boolean => {
    return marker.start !== undefined && marker.end !== undefined;
};

export const selectMarkerRow = (markers: QCReportMarker[], label: string, identifier: string): TimelineRow => {
    const type = TimelineRowType.QCReport;
    const markersWithTime: TimelineMarker[] = markers.filter(haveTimestamp) as TimelineMarker[];
    
    return {
        markers: markersWithTime,
        label,
        identifier,
        type,
    };
};

const getRow = (row: TimelineRow): TimelineRow => row;

export const qcReportTrackSelector = createSelector(selectMarkerRow, getRow);

export const mapState = (state: State): StateProps => {
    const {
        selectedMarker,
        qcReport,
    } = state.timeline;
    const {
        selectedRowId,
        selectedMarkerId,
    } = selectedMarker;
    const {markers, rowId} = qcReport;
    
    const markerRowData = qcReportTrackSelector(markers, label, rowId);
    
    return {
        markerRowData,
        selectedRowId,
        selectedMarkerId,
        tabIndex: TabIndex.QCReport,
    };
};

export const mapDispatch = {
    setMarkers: setQCReportsAction,
    resetMarkers: resetQCReportsAction,
    toggleSelectedMarker: toggleSelectedMarkerAction,
    toggleSelectedRow: toggleSelectedRowAction,
    setActiveTab: setActiveTabAction,
};

export default connect(mapState, mapDispatch)(MarkerRowContainer);
